/**
 * @generated SignedSource<<452a782843134369a5c9f9fa35f2496e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductShipping_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPrice_item">;
  readonly " $fragmentType": "ProductShipping_item";
};
export type ProductShipping_item$key = {
  readonly " $data"?: ProductShipping_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductShipping_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductShipping_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShippingPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "66a45482dc888c384c3e55d87238bc5b";

export default node;
